import { ReferenceHWState } from "../ReferenceHW/ReferenceHWState";
import { SereneHWStateProperties } from "./SereneHWStateProperties";
import { Nullable, Voidable } from "../../../types/aliases";

export enum SereneIntervalTypes {
  MEASURE,
  UPDATE
}
export class SereneHWState extends ReferenceHWState<SereneHWStateProperties> {

  private static readonly DEFAULT_INTERVAL = 15;
  private static readonly MAX_INTERVAL = 3600;
  private static readonly MIN_UPDATE_INTERVAL = 0;
  private static readonly MIN_MEASUREMENT_INTERVAL = 5;

  public static toValidInterval(value: Voidable<number>, type: SereneIntervalTypes): number {
    if (value == null) {
      return SereneHWState.DEFAULT_INTERVAL;
    }

    if (value > SereneHWState.MAX_INTERVAL) {
      return SereneHWState.MAX_INTERVAL;
    }
    const min = SereneHWState.getMinIntervalValue(type);

    if (value < min) {
      return min;
    }
    return value;
  }

  public static getMinIntervalValue(type: SereneIntervalTypes): number {
    switch (type) {
      case SereneIntervalTypes.MEASURE:
        return this.MIN_MEASUREMENT_INTERVAL;
      case SereneIntervalTypes.UPDATE:
        return this.MIN_UPDATE_INTERVAL;
      default:
        return 0;
    }
  }

  public get noModemSleep(): Nullable<boolean> {
    return this.deltaExists("noModemSleep") ? this.desired.noModemSleep : this.reported.noModemSleep;
  }

  public set noModemSleep(enabled: Nullable<boolean>) {
    this.desired.noModemSleep = enabled;
    this.changedValues.noModemSleep = enabled;
  }

  public get updateInterval(): Nullable<number> {
    return this.deltaExists("updateInterval") ? this.desired.updateInterval : this.reported.updateInterval;
  }

  public set updateInterval(value: Nullable<number>) {
    const validatedValue = SereneHWState.toValidInterval(value, SereneIntervalTypes.UPDATE);
    this.desired.updateInterval = validatedValue;
    this.changedValues.updateInterval = validatedValue;
  }

  public get measurementInterval(): Nullable<number> {
    return this.deltaExists("measurementInterval") ? this.desired.measurementInterval : this.reported.measurementInterval;
  }

  public set measurementInterval(value: Nullable<number>) {
    const validatedValue = SereneHWState.toValidInterval(value, SereneIntervalTypes.MEASURE);
    this.desired.measurementInterval = validatedValue;
    this.changedValues.measurementInterval = validatedValue;
  }

  public get logs(): Nullable<boolean> {
    return this.deltaExists("logs") ? this.desired.logs : this.reported.logs;
  }

  public set logs(enabled: Nullable<boolean>) {
    this.desired.logs = enabled;
    this.changedValues.logs = enabled;
  }
}
